<template>
  <div id="app" class="container-fluid">
    <SideBarLayout>
      <router-view :key="$route.fullPath" />
    </SideBarLayout>
  </div>
</template>

<script>
import SideBarLayout from '@/views/layouts/SideBar.vue';

export default {
  components: {
    SideBarLayout,
  },
};
</script>
